import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import { datasetUrl } from '@/constants/urls';
import datasetSharingActions from '../constants';

export function* closeTab({ destroy, code }) {
  if (destroy) {
    yield call(listener.closeTab, [datasetUrl({ code })]);
  }
}

export default function* datasetSharingLayout() {
  yield takeEvery(datasetSharingActions.SHARE_DATASET_SUCCESS, closeTab);
}
